var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.4 486.4",
    style: {
      enableBackground: "new 0 0 486.4 486.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M275.1,462c-8.1,8.1-19.4,13.2-31.8,13.2c-24.9,0-45-20.2-45-45l-0.1-374c0-24.9,20.2-45,45-45 c24.9,0,45,20.2,45,45l0.1,374C288.2,442.7,283.2,453.9,275.1,462z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M24.4,275.1c-8.1-8.1-13.2-19.4-13.2-31.8c0-24.9,20.2-45,45-45l374-0.1c24.9,0,45,20.2,45,45 c0,24.9-20.2,45-45,45l-374,0.1C43.7,288.2,32.5,283.2,24.4,275.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonAdd);
export default __webpack_public_path__ + "static/media/button-add.daae0fc36e936471ed68ba5dfd3a9503.svg";
export { ForwardRef as ReactComponent };